import { Trans } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import { RouterLink } from '@jotta/ui/RouterLink'
import { useBrandStore } from '@jotta/ui/useBrandTheme'
import { useBreakpointIndex } from '@jotta/ui/useBreakpointIndex'
import { AccountType } from '@jotta/grpc-js-client/customerService'
import type { PrivateSection } from './PrivateSection'
import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import { AppLayoutPortal } from '@jotta/ui/AppLayoutPortal'

export const SettingsTopNavBar = () => {
  const breakPointIndex = useBreakpointIndex()
  const customer = useGetCustomer().data

  return breakPointIndex < 2 ? null : (
    <AppLayoutPortal slot="moduleNav">
      <RouterLink variant="links.navbar" key="account" to="/web/account">
        <Trans id="Account and profile" />
      </RouterLink>
      <RouterLink variant="links.navbar" key="secure" to="/web/secure">
        <Trans id="Security" />
      </RouterLink>
      <RouterLink variant="links.navbar" key="billing" to="/web/billing">
        <Trans id="Subscription" />
      </RouterLink>
      {customer?.accountType === AccountType.FAMILY_OWNER && (
        <RouterLink variant="links.navbar" key="family" to="/web/family">
          <Trans id="Family members" />
        </RouterLink>
      )}
      <RouterLink variant="links.navbar" key="connected" to="/web/connected">
        <Trans id="Connected apps" />
      </RouterLink>
    </AppLayoutPortal>
  )
}

export const TopNavBar = observer<{
  section: PrivateSection
}>(function TopNavBar({ section }) {
  const layout = useBrandStore()
  const isHidden = section === 'settings' && layout.currentBreakpoint < 2

  if (isHidden) {
    return null
  }

  switch (section) {
    case 'settings':
      return <SettingsTopNavBar />
    case 'biz':
      return (
        <AppLayoutPortal slot="moduleNav">
          <RouterLink variant="links.navbar" to="/biz" end>
            <Trans>Dashboard</Trans>
          </RouterLink>
          <RouterLink variant="links.navbar" to="/biz/users">
            <Trans>Users</Trans>
          </RouterLink>
          <RouterLink variant="links.navbar" to="/biz/settings">
            <Trans>Settings</Trans>
          </RouterLink>
        </AppLayoutPortal>
      )
    default:
      return null
  }
})
